import { USCurrency } from 'components/ReusableComponents/FormattedPrice'
import HotelPlanTooltip from 'components/ReusableComponents/HotelPlanTooltip'
import Chevron from 'features/RateCodes/Chevron'
import { useHotelPlanInfo } from 'features/Hotel/useHotelPlanInfo'
import moment from 'moment'

import {
  getSubscriptionRowDisplayName,
  getSubscriptionRowDisplayRate,
  shouldShowSubscriptionRow
} from '../../hotelPlanDisplayName'
import styles from '../Services.module.scss'

export const SubscriptionsRow = ({
  plan,
  planRate,
  isFlatMonthly = true,
  startDate,
  endDate,
  packageName,
  subscriptions = []
}) => {
  const { solutionFeatures, shouldShow: shouldShowPlanTooltip } = useHotelPlanInfo(subscriptions)
  const isEnded = moment(endDate).isBefore(moment())
  const isActive = moment(startDate).isBefore(moment())
  const willStart = moment(startDate).isAfter(moment())

  if (isEnded) {
    return null
  }

  const subscription = { plan, planRate, isFlatMonthly, startDate, endDate, packageName }
  if (!shouldShowSubscriptionRow(subscription, subscriptions)) {
    return null
  }

  const isCoreTierPlan =
    plan === 'DirectfulCore' ||
    plan === 'Unlimited' ||
    plan === 'Basic' ||
    plan === 'Messaging'
  const displayName = getSubscriptionRowDisplayName(subscription, subscriptions)
  const displayRate = getSubscriptionRowDisplayRate(subscription, subscriptions)
  const showPlanTooltip = isCoreTierPlan && shouldShowPlanTooltip

  const tooltipContent = endDate
    ? `End date: ${moment(endDate).format('MMM D, YYYY')}`
    : 'No end date set'

  return (
    <div className={styles.row} data-tip={tooltipContent}>
      <div>
        <span className={styles.planNameRow}>
          <span className={styles.planName}>{displayName}</span>
          {showPlanTooltip && (
            <HotelPlanTooltip
              solutionFeatures={solutionFeatures}
              iconOnly
              iconSize={16}
              align="left"
            />
          )}
        </span>
        {isActive && (
          <p className={styles.startDate}>
            <span className={styles.active}>Active</span>
            &nbsp;since {moment(startDate).format('MMM D, YYYY')}
          </p>
        )}
        {willStart && (
          <p className={styles.startDate}>
            <span className={styles.active}>Will start</span> on{' '}
            {moment(startDate).format('MMM D, YYYY')}
          </p>
        )}
      </div>
      <span className={styles.planRate}>
        {isFlatMonthly ? <USCurrency>{displayRate}</USCurrency> : <>%{displayRate}</>}
      </span>
      <Chevron />
    </div>
  )
}
